import '../../css/v2/globals.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import TvApp from './TvApp';
import AuthApp from './AuthApp';
import { installAvatarFallback } from './lib/avatarFallback';

installAvatarFallback();

const root = document.getElementById('v2-root');

if (root) {
    const tvMode   = (window as any).__TV_MODE__?.enabled === true;
    const authPage = (window as any).__AUTH_PAGE__?.enabled === true;

    let Component = App;
    if (tvMode)   Component = TvApp;
    if (authPage) Component = AuthApp;

    createRoot(root).render(
        <StrictMode>
            <Component />
        </StrictMode>,
    );
}
